// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    ProjectMini,
    ProjectMiniFromJSON,
    ProjectMiniToJSON,
    UserMinified,
    UserMinifiedFromJSON,
    UserMinifiedToJSON,
} from './';

/**
 * 
 * @export
 * @interface Task
 */
export interface Task {
    /**
     * 
     * @type {number}
     * @memberof Task
     */
    id: number;
    /**
     * 
     * @type {ProjectMini}
     * @memberof Task
     */
    project: ProjectMini;
    /**
     * 
     * @type {UserMinified}
     * @memberof Task
     */
    user: UserMinified;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    title: string;
    /**
     * 
     * @type {boolean}
     * @memberof Task
     */
    completed?: boolean;
    /**
     * Priority, 0 - Low, 1- Normal, 2 - High
     * @type {number}
     * @memberof Task
     */
    priority?: TaskPriorityEnum;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    href: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    updatedAt: string;
}

export function TaskFromJSON(json: any): Task {
    return {
        'id': json['id'],
        'project': ProjectMiniFromJSON(json['project']),
        'user': UserMinifiedFromJSON(json['user']),
        'title': json['title'],
        'completed': !exists(json, 'completed') ? undefined : json['completed'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
        'startDate': !exists(json, 'start_date') ? undefined : json['start_date'],
        'endDate': !exists(json, 'end_date') ? undefined : json['end_date'],
        'href': json['href'],
        'createdAt': json['created_at'],
        'updatedAt': json['updated_at'],
    };
}

export function TaskToJSON(value?: Task): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'project': ProjectMiniToJSON(value.project),
        'user': UserMinifiedToJSON(value.user),
        'title': value.title,
        'completed': value.completed,
        'priority': value.priority,
        'start_date': value.startDate,
        'end_date': value.endDate,
        'href': value.href,
        'created_at': value.createdAt,
        'updated_at': value.updatedAt,
    };
}

/**
* @export
* @enum {string}
*/
export enum TaskPriorityEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}


